import { render, staticRenderFns } from "./newOrderlast.vue?vue&type=template&id=53fae4e3&scoped=true"
import script from "./newOrderlast.vue?vue&type=script&lang=js"
export * from "./newOrderlast.vue?vue&type=script&lang=js"
import style0 from "./newOrderlast.vue?vue&type=style&index=0&id=53fae4e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fae4e3",
  null
  
)

export default component.exports